var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userChallenges.length == 1)?_c(_vm.userChallenges[0].component,{tag:"component",attrs:{"challenge":_vm.userChallenges[0]}}):(_vm.userChallenges.length > 1)?_c('div'):_c('div',{staticClass:"text-black"})}
var staticRenderFns = []

export { render, staticRenderFns }